import { GenericObject } from "@mongez/reinforcements";
import { Filter } from "core/catalog";
import { useMemo, useState } from "react";
import { useFilters } from "./useFilters";

export const useSelectFilter = (filter: Filter) => {
  const { data, type } = filter as {
    data: GenericObject[];
    label: string;
    type: string;
  };

  const { activeFilters, setFilters } = useFilters();

  const [_, setSelectValues] = useState<string[]>([]);

  const currentActiveFilters = useMemo(() => {
    const filters = activeFilters[type];
    return Array.isArray(filters) ? filters : filters ? [filters] : [];
  }, [activeFilters, type]);

  // Sort the data once when the component mounts
  const sortedData = useMemo(() => {
    return [...data].sort((a, b) => {
      const idA = String(Object.values(a)[0]?.id || a.value);
      const idB = String(Object.values(b)[0]?.id || b.value);
      return idA.localeCompare(idB);
    });
  }, [data]);

  // Handle checkbox changes
  const handleCheckboxChange = (id: string, isChecked: boolean) => {
    setSelectValues((prev) => {
      let updatedValues: string[] = [];
      if (isChecked) {
        // Add the id if not already present
        updatedValues = [...prev, id];
      } else {
        // Remove the id
        updatedValues = prev.filter((value) => value !== id);
      }
      setFilters({
        [type]: updatedValues.length > 0 ? updatedValues : null,
      });

      return updatedValues;
    });
  };

  return {
    sortedData,
    type,
    currentActiveFilters,
    handleCheckboxChange,
  };
};
